import { useCallback, useEffect, useRef, useState } from 'react';
import { hasValidHTMLContent } from '@/utils/html-content';
import { DEFAULT_EMAIL_SUBJECT, getDefaultEmailBody } from '../constants';

export function useSendMessage(edition?: string) {
  const [subject, setSubject] = useState(DEFAULT_EMAIL_SUBJECT);
  const [body, setBody] = useState(getDefaultEmailBody());
  const [subjectError, setSubjectError] = useState('');
  const [bodyError, setBodyError] = useState('');
  const seededEdition = useRef(false);

  useEffect(() => {
    if (seededEdition.current || !edition?.trim()) return;
    setBody((current) =>
      current.includes('#XX') ? getDefaultEmailBody(edition) : current
    );
    seededEdition.current = true;
  }, [edition]);

  const isValid = Boolean(subject.trim()) && hasValidHTMLContent(body);

  const handleSubjectChange = useCallback((value: string) => {
    setSubject(value);
    if (value.trim()) setSubjectError('');
  }, []);

  const handleBodyChange = useCallback((value: string) => {
    setBody(value);
    if (hasValidHTMLContent(value)) setBodyError('');
  }, []);

  const validate = useCallback(() => {
    const nextSubjectError = subject.trim() ? '' : 'O Assunto é obrigatório';
    const nextBodyError = hasValidHTMLContent(body)
      ? ''
      : 'O Corpo do e-mail é obrigatório';
    setSubjectError(nextSubjectError);
    setBodyError(nextBodyError);
    return !nextSubjectError && !nextBodyError;
  }, [body, subject]);

  return {
    subject,
    body,
    subjectError,
    bodyError,
    isValid,
    onSubjectChange: handleSubjectChange,
    onBodyChange: handleBodyChange,
    validate,
  };
}
